import type {ReactNode} from 'react';
import {useParams,Navigate} from 'react-router-dom';
import {useLiveQuery} from 'dexie-react-hooks';
import {useService} from './context';
import {retiredTrialObjects} from '../application/current-product';
import {LoadingPage} from '../ui/States';
/** Guard only imported trial objects; leave unrelated navigation/focus scheduling unchanged. */
export function CurrentObjectBoundary({kind,children}:{kind:'task'|'resource';children:ReactNode}){
 const {db}=useService(),{id=''}=useParams();
 const result=useLiveQuery(async()=>{const hidden=await retiredTrialObjects(db);return {id,kind,visible:!(kind==='task'?hidden.tasks:hidden.resources).has(id)};},[db,id,kind]);
 if(!result||result.id!==id||result.kind!==kind)return <LoadingPage/>;
 return result.visible?<>{children}</>:<Navigate to="/home" replace/>;
}
